const Marquee = ({ items, className = "", textClassName = "" }) => {
  const row = (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className={`flex items-center whitespace-nowrap ${textClassName}`}>
          {item}
          <span className="mx-6 inline-block h-2.5 w-2.5 rounded-full bg-current opacity-60 md:mx-10" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div className={`overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track">
        {row}
        <div aria-hidden="true" className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={i} className={`flex items-center whitespace-nowrap ${textClassName}`}>
              {item}
              <span className="mx-6 inline-block h-2.5 w-2.5 rounded-full bg-current opacity-60 md:mx-10" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
